module.exports = __webpack_public_path__ + "img/移除网络2.ba9a4209.svg";